import { useMemo } from 'react';
import Tooltip from '@/ui/tooltip';
import { SVGPureIcon } from '@/ui';
import copy from 'copy-to-clipboard';

import { markdownToPlainText } from '@shared/utils';

import { message, Dropdown } from 'antd';
import IconButton from './IconButton';
import Feedback from './Feedback';

import chatStoreManager from '@/store/chat/manager';
import { getModelCategory, getModelName, getResultForRead } from '@shared/store/chat';
import { HelperCore } from '@/common/helper';
import modelChoiceStore from '../model-choice/store';
import HelpOther from "@src/common/helper/other";
import globalStore from '@/store/global';
import chatReadStore from '@/store/chat/chatRead';
import { observer } from 'mobx-react-lite';
import checkStore from '@/store/checkStore';
import { useRef } from 'react';
import { useMeasure } from 'react-use';
import Loader from '@/common/helper/loader';
import { useEffect } from 'react';
import { request } from '@/common';

function ActionBar(props) {
  const { className, renewable, answer, onRenew, msg_id, chatId, prompt, messageItem, isAgentWelcome } =
    props;

  const chatStore = chatStoreManager.current;
  const modelCategory = useMemo(() => {
    // debug
    if(!HelperCore.IS_ONLINE){
      const urlParams = HelperCore.getParams();
      if(urlParams.src && urlParams.src.includes("bot_")){
        const botId = urlParams.src.replace(/^bot_/, "");
        const botInfo = modelChoiceStore.chatModels[botId];
        if(botInfo.title == "DeepSeek"){
          return "编程辅助";
        }
      }
    }

    return getModelCategory(messageItem);
  }, [messageItem]);
  const modelName = useMemo(() => {
    // debug
    if(!HelperCore.IS_ONLINE){
      const urlParams = HelperCore.getParams();
      if(urlParams.src && urlParams.src.includes("bot_")){
        const botId = urlParams.src.replace(/^bot_/, "");
        const botInfo = modelChoiceStore.chatModels[botId];
        if(botInfo){
          return botInfo;
        }
      }
    }

    return getModelName(messageItem);
  }, [messageItem]);

  const $refMore = useRef(null);

  const deleteBtnClick = () => {
    chatStore.log({
      action: "click",
      set: "dele",
      message_id: msg_id,
    });

    HelpOther.confirm({
      title: '确认删除对话',
      okText: "删除",
      content: (
        <div className="whitespace-nowrap">
          确定要删除对话吗？删除后对话内容将不可恢复。
        </div>
      ),
      onOk: () => {
        chatStore.mcpStore.setShowRightPanel(false);
        chatStore.mcpStore.setCurrentPanelId(null);
        chatStore.deleteMessage(msg_id).then(code => {
          if (code == 0) {
            message.success('消息删除成功');
          } else {
            message.error('消息删除失败');
          }
        });
      },
    });
  };

  const dropList = () => {
    return (
      <div
        className={`w-[168px] px-[8px] py-[8px] rounded-[16px] flex flex-col gap-[4px] ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
        style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.1)' }}
      >
        <div
          className={`w-full h-[40px] rounded-[12px] font-bold text-[14px] text-[#FF5959] left-[8px] flex items-center gap-[8px] cursor-pointer hover:bg-[#FF5959] hover:bg-opacity-10 ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
          onClick={() => {
            deleteBtnClick();
          }}
        >
          <IconButton className='!hover:bg-transparent' icon="competitive-chat-drop-delete" size={20}></IconButton>
          删除
        </div>
      </div>
    );
  };

  const [$refContainer, { width: widthContainer }] = useMeasure();
  const isSmall = widthContainer < Loader.size.actionSmall;
  const isMcpServer = chatStore.lastMessage?.cloud_mcp?.length > 0 || chatStore.lastMessage?.mcp?.length > 0;

  //缓存耗时等信息 business todo
  useEffect(() => {
    if(messageItem?.cost){
       request.post('/assistant/conversation/mark', {
        conversation_id: chatId,
        msg_id,
        token_speed: JSON.stringify(messageItem?.cost),
      });
    }
  }, [messageItem?.cost]);

  const renderCost = () => {
    return messageItem?.cost?.time && !globalStore.isKownledgeChat() && globalStore.cloudConfig.webConfig?.support_cost_time == 1
    ? (
      <div className={`${isSmall ? 'mb-20px' : 'w-0 flex-grow justify-end'} flex truncate opacity-60 text-13px`}>
        <div className="">{`本次回答耗时${messageItem.cost.time}秒`}</div>
        {
          messageItem.cost.token
          ? (
            <>
              <div className="px-10px">|</div>
              <div className="">{`输出速度: ${messageItem.cost?.speed ? messageItem.cost?.speed : Math.ceil(messageItem.cost.token / messageItem.cost.time)} tokens/s`}</div>
            </>
          )
          : null
        }
      </div>
    )
    : null
  }

  return (
    <div className="flex flex-col w-full" ref={$refContainer}>
      {
        isSmall ? renderCost() : null
      }
      <div className={['flex items-center', className]}>
        <section className="flex items-center gap-[12px]">
          {
            chatStore.mcpStore.isMcpAgent || isMcpServer
            ? null
            : (
              <Tooltip title="复制">
                <button
                  className="hover:bg-gray-nav-hover rounded-[8px] cursor-pointer outline-none border-none"
                  icon="copy"
                  size={16}
                  onClick={async () => {
                    if (messageItem.role_biz === 'draw') {// 复制图片
                      const src = messageItem.tti_image;
                      const response = await fetch(src);
                      const blob = response.blob();
                      const data = [new ClipboardItem({
                          [blob.type || 'image/' + src.split('.').slice(-1)[0].replace('jpg', 'jpeg')]: blob
                      })];
                      navigator.clipboard.write(data).then(()=>{message.success('复制成功')}, ()=>{});
                    } else {
                      const plainText = markdownToPlainText(answer);
                      const copied = copy(plainText);
                      copied && message.success('复制成功');
                    }
                    chatStore.log({
                      action: "click",
                      set: "copy",
                      message_id: msg_id,
                    });
                  }}
                >
                  <SVGPureIcon name="copy" size={28} />
                </button>
              </Tooltip>
            )
          }

          {renewable && !isAgentWelcome && (
            <Tooltip title="再试一次">
              <button
                className="hover:bg-gray-nav-hover rounded-[8px] cursor-pointer outline-none border-none"
                icon="sync"
                onClick={() => {
                  onRenew?.();
                  chatStore.log({
                    action: 'click',
                    set: 're_generate',
                    message_id: msg_id,
                  });
                }}
              >
                <SVGPureIcon name="sync" size={28} />
              </button>
            </Tooltip>
          )}

          {globalStore.globalConfig.supportRead && chatReadStore.isSupportReadMessage(messageItem) && (
            <Tooltip title="朗读">
              <button
                className={`hover:bg-gray-nav-hover size-28px flex items-center justify-center rounded-[8px] cursor-pointer outline-none border-none}`}
                onClick={() => {
                  chatStore.log({
                    action: "click",
                    set: "read",
                    message_id: msg_id,
                  });

                  chatReadStore.handleClick({
                    conversationId : chatId,
                    messageId : msg_id,
                    content : getResultForRead(messageItem.result),
                    roleId : messageItem.role_id,
                    agentId: chatStore.agentId,
                  });
                }}
              >
                <SVGPureIcon
                  className={`${chatReadStore.conversationId == chatId && chatReadStore.messageId == msg_id && !chatReadStore.readStore.hasTrasFirst ? 'ani-rotate' : ''}`}
                  name={chatReadStore.conversationId == chatId && chatReadStore.messageId == msg_id ? (chatReadStore.readStore.hasTrasFirst ? "competitive-chat-stop" : "loading") : "read"}
                  size={28}
                />
              </button>
            </Tooltip>
          )}

          {
            globalStore.isKownledgeChat()
            ? null
            : (
              <Tooltip title="分享">
                <div
                  className="hover:bg-gray-nav-hover rounded-[8px] cursor-pointer h-[28px] px-[8px] flex items-center"
                  onClick={() => {
                    chatStore.log({
                      action: "click",
                      set: "share",
                      message_id: msg_id,
                    });

                    if(chatStore.mcpStore.isMcpAgent || isMcpServer || chatStore.mcpStore.isAgentFlow){
                      chatStore.mcpStore.copyShareUrl();
                      return;
                    }

                    checkStore.setData({
                      isShowCheck: true
                    })
                    checkStore.setChecked(`${msg_id}-p`, true)
                    checkStore.setChecked(`${msg_id}-r`, true)
                    if(checkStore.data.checkList.length < 2 * chatStore.messageList.length) return
                    checkStore.setData({
                      allChecked: checkStore.data.checkList.every(item => item.checked)
                    })
                  }}
                >
                  <SVGPureIcon name="chat_item_share" size={14} className='opacity-60' />
                  <div className='text-[13px] ml-[6px] opacity-60'>分享</div>
                </div>
              </Tooltip>
            )
          }

          {!isAgentWelcome && chatStore.isOwner ? <Dropdown
            dropdownRender={() => dropList()}
            trigger="hover"
            placement="topLeft"
            getPopupContainer={
              () => {
                return $refMore.current;
              }
            }
          >
            <div className="size-28px" ref={$refMore}>
              <IconButton
                className='!hover:bg-gray-nav-hover !p-0'
                iconClassName='text-[rgb(0,0,0,.5)]'
                icon="more"
                size={28}
                onClick={() => {
                  chatStore.log({
                    action: "click",
                    set: "more",
                    message_id: msg_id,
                  });
                }}
              />
            </div>
          </Dropdown>:null}
        </section>

        <span className='w-1px h-13px mx-12px bg-black bg-opacity-10'></span>

        <div className="flex items-center flex-shrink-0 text-13px text-primary-opacity">
          {
            modelCategory
            ? <div className="flex-shrink-0">{modelCategory ? `类型：xxxx` : ''}</div>
            : null
          }
          {
            modelName
            ? (
              <div className='h-full flex items-center'>
                <img src={modelName.icon} className='size-20px mr-6px' />
                <div>{modelName.title}</div>
              </div>
            )
            : null
          }
          <Feedback {...{ msg_id, chatId, prompt, messageItem }} />
        </div>

        {
          !isSmall ? renderCost() : null
        }
      </div>
    </div>
  );
}

export default observer(ActionBar);
